<canvas
  baseChart
  [data]="chartData"
  [labels]="chartLabels"
  [options]="chartOptions"
  [type]="chartType"
  [attr.aria-label]="ariaLabel"
></canvas>
